import { Box, TextInput } from '@hover/blueprint';
import React, { useEffect, useState } from 'react';
import {
  Control,
  Controller,
  FieldValues,
  UseFormSetValue,
  useWatch,
} from 'react-hook-form';
import { IDropdownItem } from '../../../interfaces/IDropdownItem';
import { IJobDemographicQuestion } from '../../../interfaces/IJobDemographicQuestion';
import Dropdown from './Dropdown';

interface Props {
  control: Control;
  demographicQuestion: IJobDemographicQuestion;
  dropdownList: Array<IDropdownItem>;
  setValue: UseFormSetValue<FieldValues>;
}

const DemographicQuestion: React.FC<Props> = ({
  control,
  demographicQuestion,
  dropdownList,
  setValue,
}) => {
  const [showInput, setShowInput] = useState<boolean>(false);
  const currentValue = useWatch({
    control,
    name: demographicQuestion.id.toString(),
  }) as Array<{ answer_option_id: number; text: string }>;

  useEffect(() => {
    if (!currentValue) {
      setShowInput(false);
    }
  }, [currentValue]);

  const freeFormOption = demographicQuestion.answer_options.find(
    option => option.free_form,
  );

  const onChangeText = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value },
    } = event;
    if (currentValue) {
      setValue(demographicQuestion.id.toString(), [
        ...currentValue.filter(
          cv => cv.answer_option_id !== freeFormOption?.id,
        ),
        {
          answer_option_id: freeFormOption?.id,
          text: value,
        },
      ]);
    }
  };

  const isMultiSelect = () => {
    if (
      demographicQuestion.label === 'Gender' ||
      demographicQuestion.label === 'Race & Ethnicity Identity\t'
    ) {
      return false;
    }
    return demographicQuestion.type === 'multi_value_multi_select';
  };

  return (
    <Box w="100%" flexDir="column" key={demographicQuestion.id}>
      <Controller
        control={control}
        name={demographicQuestion.id.toString()}
        render={({ field }) => (
          <Dropdown
            value={field.value as Array<IDropdownItem>}
            placeholder={demographicQuestion.label}
            multiSelect={isMultiSelect()}
            onChangeValue={selectedValues => {
              const existFreeForm = selectedValues.find(
                sv => sv.key === freeFormOption?.id,
              );
              setShowInput(!!existFreeForm);
              const normalizedSelectedValues = selectedValues.map(sv => ({
                answer_option_id: sv.key,
                text: '',
              }));
              field.onChange(normalizedSelectedValues);
            }}
            mb={showInput ? 400 : 600}
            items={dropdownList}
          />
        )}
      />
      {showInput && (
        <TextInput
          borderColor="neutral.300"
          _placeholder={{
            fontWeight: 700,
            fontSize: '12px',
            color: 'brandNavy.300',
            letterSpacing: '0.1rem',
          }}
          mb={600}
          placeholder="SELF DESCRIBE"
          onChange={onChangeText}
        />
      )}
    </Box>
  );
};

export default DemographicQuestion;
